/**
 * @author Ivan Toth.
 */
var DetailTableIgFgoeController = (function () {
    function DetailTableIgFgoeController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'goe_data';
        this.requiredCountrySearch = true;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = true;
        this.bol = false;
        this.selectedCustName = [];
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '5000';
        this.cmrData.showCapRecords = true;
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = true;
        this.expand = false;
        this.dataSources = ['GOE'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    DetailTableIgFgoeController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableIgFgoeController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableIgFgoeController.prototype.$onInit = function () {
        if (this.$attrs.data) {
            this.comp = this.$attrs.data;
            this.dataSources = ['GOE_VALID'];
        }
        else {
            this.comp = 'goe_data';
        }
    };
    DetailTableIgFgoeController.prototype.errorChecker = function () {
        if (this.cmrData.cmrNum === null) {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableIgFgoeController.prototype.nameChecker = function () {
        if (this.cmrData.fuzzySearch === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
        }
    };
    DetailTableIgFgoeController.prototype.sendDupliCheck = function (opp) {
        if (this.cmrData.fuzzySearch === '' && this.cmrData.cmrNum === '') {
            this.errorCheckerInput = true;
        }
        else {
            this.errorCheckerInput = false;
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.cmrData.opp = opp;
                this.cmrData.ds = this.comp === 'goe_valid' ? 'GOE_VALID' : 'GOE_DATA';
                this.processing = true;
                //console.info('detail.table.ig.fgoe (sendDupliCheck) => socket getFuzzyResults', this.cmrData);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getFuzzyResults',
                        script: '/detail/eligibility/eligibility',
                        data: this.cmrData,
                        token: this.env.user.token,
                        bID: this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
            ;
        }
    };
    DetailTableIgFgoeController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableIgFgoeController;
}());
var DetailTableIgFgoeComponent = (function () {
    function DetailTableIgFgoeComponent() {
        this.templateUrl = 'detail-table-ig-find-goe.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableIgFgoeController;
    }
    return DetailTableIgFgoeComponent;
}());
angular
    .module('application')
    .component('detailTableIgFindGoe', new DetailTableIgFgoeComponent());

//# sourceMappingURL=detail.table.ig.fgoe.component.js.map
